<template>
    <v-alert 
        v-if="hasNoResponseEDocument" 
        :value="true" 
        color="warning" 
        icon="edit" 
        outline 
        class="mt-8 rounded-4"
        >
        You have pending <b>HR documents</b> that require your response. 
        Please review and submit your response to ensure timely compliance.
        
        <span class="mt-2">
            <router-link to="/hr/myedocuments" class="font-weight-bold">
            Go to My eDocuments
            </router-link>
        </span>
    </v-alert>
</template>

<script>

import edocumentsApi from '@/api/edocuments'

export default {     
    name: 'EDocumentsNoResponseBanner',
    data () {
        return {
            error: false,
            errorMessage: '',
            loading: false,
            hasNoResponseEDocument: false,
        }
    },
    methods: {
        async getHasNoResponseDocuments() {
            try {   
                const response = await edocumentsApi.hasNoResponse()
                if (response && response.status == 200) {
                    this.hasNoResponseEDocument = response.data
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {
        this.getHasNoResponseDocuments()
    }
}
</script>